import HallList from "./hall-list";

import "./hall-list.scss";


const HallLists = {
    Selection : HallList
}

export default HallLists;